import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '@/store/index'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Terms from '../views/terms-of-use.vue'
// import Privacy from '../views/privacy-policy.vue'
import Category from '@/components/Categories/SingleCategory.vue'
import Dashboard from '@/components/Dashboard/Dashboard.vue'
import MyCourses from '@/components/Dashboard/Courses/MyCourses'
import CategoryCourses from '@/components/Courses/CategoryCourses'
import AllCourse from '@/components/Courses/Courses.vue'
import Lecturer from '@/components/Courses/LectureList.vue'
import Search from '@/components/Courses/CourseList.vue'
import Register from '@/components/Auth/_partials/Register'
import Login from '@/components/Auth/_partials/Login'
// import Cart from '@/components/Cart/Cart'
import SingleCourse from '@/components/Courses/SingleCourse'
// import MyCourseDetail from '../components/Dashboard/Courses/SingleCourse.vue'
import MyCourseVideo from '../components/Dashboard/Courses/SingleCoursePlay.vue'
import Profile from '../components/Dashboard/Profile.vue'
import ProfileUpdate from '../components/Dashboard/Profile-Update.vue'
// import CourseVideo from '@/components/Courses/SingleCoursePlay'
import NoContent from '../components/Courses/NoContent.vue'
import Esewa from '../components/Courses/EsewaForm.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    name: 'Home',
    meta: {
      authentication: false
    }
  },
  {
    path: '/about',
    component: About,
    name: 'About',
    meta: {
      authentication: false
    }
  },
  {
    path: '/terms-of-use',
    component: Terms,
    name: 'TermsOfUse',
    meta: {
      authentication: false
    }
  },
  // {
  //   path: '/privacy-policy',
  //   component: Privacy,
  //   name: 'PrivacyPolicy',
  //   meta: {
  //     authentication: false
  //   }
  // },
  {
    path: '/login',
    component: Login,
    name: 'login',
    meta: {
      authentication: false,
    }
  },
  {
    path: '/register',
    component: Register,
    name: 'register',
    meta: {
      authentication: false,
      // hideNavigation: true
    }
  },
  {
    path: '/category',
    name: 'Category',
    component: Category
  },
  {
    path: '/allcourse',
    name: 'AllCourse',
    component: AllCourse
  },
  {
    path: '/lecturer',
    name: 'AllTeacher',
    component: Lecturer
  },
  {
    path: '/course/:course_id/detail',
    name: 'course-detail',
    component: SingleCourse
  },
  {
    path: '/pay/esewa',
    name: 'EsewaForm',
    component: Esewa
  },
  // {
  //   path: '/mycourse/:course_id/detail',
  //   name: 'MyCourseDetail',
  //   component: MyCourseDetail,
  //   meta: {
  //     authentication: true,
  //   }
  // },
  // {
  //   path: '/course/:course_id/video',
  //   name: 'SingleCoursePlay',
  //   component: CourseVideo
  // },
  {
    path: '/mycourse/:course_id/video',
    name: 'MyCourseVideo',
    component: MyCourseVideo,
    meta: {
      authentication: false,
    }
  },
  // {
  //   path: '/cart',
  //   name: 'Cart',
  //   component: Cart,
  //   meta: {
  //     authentication: false
  //   }
  // },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      authentication: true
    }
  },
  {
    path: '/mycourses',
    name: 'MyCourse',
    component: MyCourses,
    meta: {
      authentication: false
    }
  },
  {
    path: `/course/`,
    name: 'CategoryCourses',
    component: CategoryCourses
  },
  {
    path: '/search/',
    name: 'search',
    component: Search
  },
  {
    path: '/page-not-found',
    name: 'NoContent',
    component: NoContent
  },
  {
    path: '/profile/',
    name: 'Profile',
    component: Profile,
    meta: {
      authentication: true
    }
  },
  {
    path: '/profile/edit',
    name: 'ProfileUpdate',
    component: ProfileUpdate,
    meta: {
      authentication: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
